import React, { Component } from "react";
import { connect } from "react-redux";
import styled, { withTheme } from "styled-components";
import OpenBook from "../icons/OpenBook";
import { selectors as booksSelectors } from "../../../../redux/books";
import { selectors as brandSelectors } from "../../../../redux/brand";
import { selectors as bridgeSelectors } from "../../../../redux/bridge";
import { actions as modalActions } from "../../../../redux/modals";
import moment from "moment";
import {
  styledMedia,
} from "../../../components/mediaquery/breakpoints";
import { BaseContainer } from "./base-container";
import Right from "./right";
import { PrimaryTransparentButton } from "../book/BookIcons";
import { selectors as routerSelectors } from "../../../../redux/router";


const FooterContainer = styled(BaseContainer)`
  align-items: center;
  display: flex;
  flex: 0 0 auto;
  font-size: 1.6rem;
  font-weight: 500;
  justify-content: space-between;
  letter-spacing: 1px;
  line-height: 19px;
  text-align: center;
`;

const FooterInnerLeft = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  width: 50%;

  .divider {
    background: #516dbb;
    height: 35px;
    border-right: 1px solid #516dbb;
    margin: 0 30px;
    ${styledMedia.medium`
      margin: 0 15px;
    `}
  }

  .stats {
    text-align: center;
    text-transform: uppercase;
    &.last-days {
      margin-right: 30px;
      ${styledMedia.medium`
        margin-right: 15px;
      `}
    }

    .info {
      display: flex;
      align-items: center;
      justify-content: center;
      margin-bottom: 3px;

      .value {
        margin-right: 5px;
      }

      .outstanding {
        font-weight: bold;
        font-size: 30px;
        color: ${props => props.theme.color.white};
      }
    }

    .text {
      font-size: 12px;
      font-weight: 300;
    }
  }
`;

const CreditsView = styled.div`
  display: flex;
  align-items: center;
  align-content: center;
  width: 55%;
  button {
    margin-left: 20px;
  }
`;

class DefaultFooter extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  getBooksOpened() {
    const { books, isbns } = this.props;
    let booksRead = 0;
    if (books && isbns) {
      booksRead = this.props.books(isbns).filter(book => {
        // if just activated, book might not be on license
        if (!book) {
          return false;
        }
        const now = moment(new Date()); //todays date
        const end = moment(book.viewedAt); // last view date
        const duration = moment.duration(now.diff(end));
        const days = duration.asDays();
        if (days < 30) {
          return book.viewedAt;
        }
        return false;
      }).length;
    }
    return booksRead;
  }

  getButtonText(){
    return i18n.t("footer.borrowed-items");
  }

  render() {
    const {
      chegg,
      offset,
      redeem,
      theme,
      needsCreditsView,
      isNative
    } = this.props;
    const statsView = (
      <FooterInnerLeft>
        <div className="stats last-days">
          <div className="info">
            <div className="value">{i18n.t("footer.last-days")}</div>
          </div>
        </div>
        <div className="stats">
          <div className="info">
            <div className="value outstanding">{this.getBooksOpened()}</div>
            <OpenBook width={28} height={21} />
          </div>
          <div className="text">{i18n.t("footer.books-opened")}</div>
        </div>
      </FooterInnerLeft>
    );

    const creditsView = (
      <CreditsView>
        <PrimaryTransparentButton
         color="white"
          onClick={() => {
            this.props.openModal("CreditsModal");
          }}
        >
          {this.getButtonText()}
        </PrimaryTransparentButton>
      </CreditsView>
    );
    return (
      <FooterContainer offset={offset}>
        {needsCreditsView ? creditsView : statsView}
        {!isNative && (
          <Right
            chegg={chegg}
            redeem={redeem}
            showRedeem={this.props.showRedeem}
            theme={theme}
          />
        )}
      </FooterContainer>
    );
  }
}

const mapStateToProps = state => ({
  books: isbns => booksSelectors.getBooks(state, isbns),
  chegg: brandSelectors.getBrandValue(state, "Chegg.isCheggBrand", false),
  isbns: booksSelectors.getIsbns(state),
  showRedeem: brandSelectors.getBrandValue(state, "Menu.redeem"),
  needsCreditsView: bridgeSelectors.hasAnyReturnableOrLimitedUserCredits(state),
  availableUserCreditCount: bridgeSelectors.getAvailableUserCreditCount(state),
  totalUserCreditCount: bridgeSelectors.getTotalUserCreditCount(state),
  usedUserCreditCount: bridgeSelectors.getUsedUserCreditCount(state),
  anyUserCreditsAreUnlimited: bridgeSelectors.anyUserCreditsAreUnlimited(state),
  isNative: routerSelectors.isNative(state)
});

const mapDispatchToProps = dispatch => ({
  openModal: (modal, props) => dispatch(modalActions.openModal(modal, props))
});

export default withTheme(
  connect(mapStateToProps, mapDispatchToProps)(DefaultFooter)
);
